module.exports = __webpack_public_path__ + "img/mundo.33d32bc9.png";